import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { HeaderContext } from "@tanstack/react-table";

export const SpecialRulesHeader = ({ column }: HeaderContext<any, unknown>) => {
  return (
    <DataTableColumnHeader
      column={column}
      title="Sonderregeln"
      style={{ padding: "5px" }}
    />
  );
};
